import React, { PropsWithChildren, useEffect, useState } from "react";

type Props = {
  enabled: boolean;
  delay?: number;
};

const ShowAfterDelay: React.FC<PropsWithChildren<Props>> = ({
  delay = 3000,
  enabled,
  children
}) => {
  const [showComponent, setShowComponent] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const timeout = setTimeout(() => {
      setShowComponent(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, [delay, enabled]);

  if (!showComponent) return null;

  return <React.Fragment>{children}</React.Fragment>;
};

export default ShowAfterDelay;
